import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentType} from "../../types/agent.type";

export class AgentTypeSelectCtrl implements IController {

  agentType: any;
  ngRequired: any;
  ngPlaceholder: any;
  ngDisabled: boolean;
  options: any;

  onChange: Function;

  private types: any;
  private permissions: any;
  private selectOptions: any;

  public agentTypes: typeof AgentType = AgentType;

  constructor(private agentConstants, private $mdSelect) {
  }

  $onInit() {
    this.types = this.agentConstants.types;
    this.permissions = this.agentConstants.permissionsByType;

    this.selectOptions = !this.options ? _.map(this.types,(t) => {
      const permissionsRef = this.permissions[t];
      return {value: t, permission:  _.get(permissionsRef, 'update')}
    }) : _.map(this.options,(o) => {
      return {value: o};
    })
  }

  reset() {
    this.onChange({agentType: undefined});
    this.$mdSelect.hide();
  }

  cancel() {
    this.$mdSelect.hide();
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentTypeSelect', {
    bindings: {
      agentType: '<',
      ngRequired: '@?',
      ngPlaceholder: '@?',
      ngDisabled: '<?',
      options: '<?',
      enableAll: '<?',
      onChange: '&'
    },
    template: require('./agent-type-select.html').default,
    controller: AgentTypeSelectCtrl
  });
